module.exports = __webpack_public_path__ + "img/donation_certificate.3a802797.jpg";